<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/personExperienceList' }">经历</el-breadcrumb-item>
                <el-breadcrumb-item>经历{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    v-show="
                                        fieldTypeMap[item.prop]['show_flag']
                                            ? fieldTypeMap[item.prop]['show_flag'] == show_flag
                                                ? 1
                                                : 0
                                            : 1
                                    "
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || []"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :request_params="fieldTypeMap[item.prop]['request_params']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                        :is_disable="type == 'update' && item['prop'] == 'person_rid'"
                                        :is_init="item['prop'] == 'type' ? false : true"
                                    ></vDropdown>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'search_select'"
                                    v-show="
                                        fieldTypeMap[item.prop]['show_flag']
                                            ? fieldTypeMap[item.prop]['show_flag'] == show_flag
                                                ? 1
                                                : 0
                                            : 1
                                    "
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || []"
                                    :prop="item['prop']"
                                >
                                    <vSearchSelect
                                        :model_key="item.prop"
                                        :model_name="'请输入' + fieldTypeMap[item.prop]['title'] + '搜索'"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :default_option_key="fieldTypeMap[item.prop]['default_option_key']"
                                        :default_option="formData[fieldTypeMap[item.prop]['default_option_key']]"
                                        @onDropChange="onDropChange"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vSearchSelect>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'date'"
                                    :key="index"
                                    v-show="
                                        fieldTypeMap[item.prop]['show_flag']
                                            ? fieldTypeMap[item.prop]['show_flag'] == show_flag
                                                ? 1
                                                : 0
                                            : 1
                                    "
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || []"
                                    :prop="item['prop']"
                                >
                                    <el-date-picker
                                        v-model="formData[item['prop']]"
                                        :type="fieldTypeMap[item.prop]['date_type']"
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :format="fieldTypeMap[item.prop]['format']"
                                        :value-format="fieldTypeMap[item.prop]['value_format']"
                                        size="mini"
                                        clearable
                                    >
                                    </el-date-picker>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else
                                    v-show="
                                        fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['show_flag']
                                            ? fieldTypeMap[item.prop]['show_flag'] == show_flag
                                                ? 1
                                                : 0
                                            : 1
                                    "
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || []"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        :disabled="type == 'update' && item['prop'] == 'code'"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, processColDataToEdit } from '@/js/common.js';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    name: 'personExperienceEdit',
    components: {
        vSearchSelect
    },
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {}, // 表单验证信息
            show_flag: 0
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        } else {
            this.data.approval_status = 2;
            this.data.person_rid = this.$route.query.person_rid || '';
            this.initFormData();
        }
    },
    methods: {
        onDropChange(key, value) {
            if (key == 'classification') {
                this.show_flag = value;

                this.$refs.type_ref[0].request_params.classification = value;
                this.$refs.type_ref[0].initData();
            }
            this.formData[key] = value;
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                classification: {
                    request_uri: 'dropdownExperienceClassification',
                    title: '类别',
                    ref: 'classification_ref',
                    display_name: 'name',
                    select_value: 'value',
                    type: 'dropdown'
                },
                type: {
                    request_uri: 'dropdownExperienceType',
                    title: '类型',
                    ref: 'type_ref',
                    display_name: 'name',
                    select_value: 'value',
                    type: 'dropdown',
                    request_params: { classification: 0 }
                },
                educational: {
                    request_uri: 'dropdownEducational',
                    title: '学历',
                    ref: 'educational_ref',
                    display_name: 'name',
                    select_value: 'value',
                    type: 'dropdown',
                    show_flag: 2
                },
                specialized: {
                    show_flag: 2
                },
                position: {
                    show_flag: 1
                },
                person_rid: {
                    request_uri: 'dropdownPerson',
                    title: '人员',
                    ref: 'person_rid_ref',
                    type: 'dropdown'
                },
                start_date: {
                    title: '开始日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'start_date_ref',
                    type: 'date'
                },
                end_date: {
                    title: '结束日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'end_date_ref',
                    type: 'date'
                }
            };
        },
        initFormRule() {
            this.rules = {
                code: [{ required: true, message: '请输入代码', trigger: 'blur' }],
                entity: [{ required: true, message: '请输入单位', trigger: 'blur' }],
                classification: [{ required: true, message: '请选择类别', trigger: 'blur' }],
                type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
                person_rid: [{ required: true, message: '请选择人员', trigger: 'blur' }],
                start_date: [{ required: true, message: '请选择开始日期', trigger: 'blur' }],
                end_date: [{ required: true, message: '请选择结束日期', trigger: 'blur' }]
            };
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        initFormData() {
            this.formData = {
                rid: this.data.rid || '',
                code: this.data.code || '',
                start_date: this.data.start_date || '',
                end_date: this.data.end_date || '',
                person_rid: this.data.person_rid || '',
                classification: this.data.classification || '',
                type: this.data.type || '',
                entity: this.data.entity || '',
                position: this.data.position || '',
                educational: this.data.educational || '',
                specialized: this.data.specialized || '',
                remark: this.data.remark || ''
            };
            this.show_flag = this.data.classification;
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('detailList')).person_experience;

            processColDataToEdit(
                temp,
                this,
                {
                    white: ['start_date', 'end_date', 'code', 'entity', 'position', 'specialized', 'remark']
                },
                {
                    classification_label: 'classification',
                    type_label: 'type',
                    educational_label: 'educational',
                    person: 'person_rid'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/personExperienceList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .personExperienceDetail(this.queryParams)
                .then((res) => {
                    // 编辑或复制页面，如果审批状态不是草稿或审批中，默认为审批中
                    if (!in_array(res.data.approval_status, [1, 2])) {
                        res.data.approval_status = 2;
                    }

                    this.data = res.data;

                    this.initFormData();
                    window.setTimeout(() => {
                        this.onDropChange('classification', res.data.classification);
                    }, 500);
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'personExperienceUpdate';
            } else {
                uri = 'personExperienceInsert';
            }
            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>